var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-form',{ref:"FORM_NAME",model:{value:(_vm.isFormValid),callback:function ($$v) {_vm.isFormValid=$$v},expression:"isFormValid"}},[_vm._t("default",null,{"onAction":_vm.onAction,"changed":_vm.changed,"actionEnabled":_vm.actionEnabled,"isFormValid":_vm.isFormValid})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }